import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Tradable } from "@models/interfaces/tradable";
import { CoreModule } from "@modules/core/core.module";

@Component({
	selector: "web3-display-ui",
	imports: [CoreModule],
	templateUrl: "./web3-display.component.html",
	styleUrl: "./web3-display.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class Web3DisplayComponent {
	@Input() amount = 0;
	@Input() tradable: Tradable = undefined;
}
